import { useCallback, useState } from "react";
import { useSnackbar } from "notistack";

import { useIntl } from "react-intl";
import { getResponseMessage } from "../../../../../utils";
import { getMessagesGPT } from "../../../../../crud/users.crud";

export type TMessageGPT = {
  content: string;
  date: string;
  id: string;
  role: "assistant" | "user";
  error?: {
    message: string;
  };
};

export const useGetMessagesGPT = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loadingGPT, setLoading] = useState(false);
  const [messagesGPT, setMessages] = useState<TMessageGPT[]>([]);

  const fetchMessagesGPT = useCallback(async (user_id?: number | string) => {
    setLoading(true);
    getMessagesGPT(user_id)
      .then((res: any) => {
        setMessages(res.data.data.filter((i: TMessageGPT) => !!i && !!i?.content));
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: "ERROR" })}: ${getResponseMessage(e)}`, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const clearMessages = useCallback(() => {
    setMessages([]);
  }, []);

  return {
    fetchMessagesGPT,
    loadingGPT,
    messagesGPT,
    clearMessages,
  };
};
